import { DeleteFilled } from "@ant-design/icons";
import React from "react";
import styled from "styled-components";
import { COLORS } from "../../constants/colors";


interface Props {
    text?: React.ReactNode;
    method?: () => void;
    color: string;
    props?: any;
    backgroundColor?: string;
    disabled?: boolean;
}

const ButtonGrapper = styled.div<Props>`
    background-color: ${props => props.backgroundColor};
    border-radius: 5px;
    overflow: hidden;
    border: 1px solid ${props => props.color};
    transition: all 0.07s;
    /* height: 40px; */
    cursor: pointer;
    color: ${props => props.color};
    font-size: 1.1em;
    padding: 10px;
    justify-content: center;
    display: flex;
    align-items: center;


    ${(props) => props.disabled?.toString() === 'true' && {
        opacity: 0.6,
    }}
   
    ${(props) => props.disabled?.toString() === 'false' && `
        :active {
            opacity: 0.7;
        }
    `}

`;

const OutLineButton = ({ method, text, color, props, backgroundColor = COLORS.transparent_color1, disabled = false }: Props): JSX.Element => {

    return (
        <ButtonGrapper {...props} color={color} onClick={disabled ? null : method} backgroundColor={backgroundColor} disabled={disabled}>
            {text}
        </ButtonGrapper>
    )
}


export default OutLineButton;